export default "__VITE_ASSET__BxnqQTjI__"